import { memo } from 'react';
import { useBillingScheinStatus } from 'hooks/useBillingScheinStatus';
import { BillingScheinBanner } from './BillingScheinBanner';

export const BillingScheinAlert = memo(function BillingScheinAlert({
  medatixxPatientId,
}: {
  medatixxPatientId?: string;
}) {
  const { data, isFetching, refetch } = useBillingScheinStatus(medatixxPatientId);

  return (
    <BillingScheinBanner
      key={medatixxPatientId}
      scheinStatus={data}
      isRechecking={isFetching}
      onRecheck={() => void refetch()}
    />
  );
});
